import { QUERY_KEYS } from "@/config/query.config";
import { type AnnouncementUser, getAnnouncementUser } from "@/services/real/auth.service";
import { useQuery } from "@tanstack/react-query";

export function useAnnouncementUser(address: string) {
    const { data, isLoading, error } = useQuery<AnnouncementUser | null>({
        queryKey: QUERY_KEYS.ANNOUNCEMENT.USER(address),
        queryFn: () => getAnnouncementUser(address),
    });

    return { data, isLoading, error };
}
